// extracted by mini-css-extract-plugin
export default {"productPage":"Program_productPage__zKsTU","titleGroup":"Program_titleGroup__bvNKg","filterGroup":"Program_filterGroup__3NPRR","productGroup":"Program_productGroup__sD8FZ"};